import { ReactNode } from 'react';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';
import { Paragraph } from './Text';

const Container = styled(Flex)`
	width: 100%;
	background-image: ${(props) => props.theme.images.lineGradient};
	text-align: center;

	${Paragraph} {
		color: ${(props) => props.theme.colors.white};
	}

	svg path {
		fill: ${(props) => props.theme.colors.white};
	}
`;

export function StatusBar(props: { text?: ReactNode | string; icon?: ReactNode }) {
	return (
		<Container px={3} py={2} justifyContent="center" alignItems="center">
			<Box size={16} mr={2}>
				{props.icon}
			</Box>
			<Paragraph>{props.text}</Paragraph>
		</Container>
	);
}
